/* eslint-disable react/no-array-index-key */
import React, { useEffect, useMemo } from 'react';
import { Grid } from '@mui/material';
import { useForm, useFormState } from 'react-final-form';
import get from 'lodash.get';

import InputField, { evaluateVisibility } from '../../../Components/InputField';

export default function MainParticipantPrompt({ steps, params, attributeQuotas }) {
  const form = useForm();
  const { values } = useFormState();
  const fields = useMemo(() => {
    if (params?.customFieldDefinition) {
      return params?.customFieldDefinition.map((el) => {
        const quotas = attributeQuotas?.[el.name?.replace?.('customAttributes.', '')];
        if (!['autocomplete', 'radio', 'select'].includes(el.type) || !quotas) return el;
        const options = el.options.map((option) => {
          const quota = quotas[option.value];
          if (!quota) return option;
          const disabled = !quota.available;
          if (!disabled) return { ...option, disabled: false };
          const orgName = option.orgName || option.name;
          return {
            ...option,
            disabled: true,
            orgName,
            name: `${orgName} - Bereits ausgebucht`,
          };
        });
        return { ...el, options };
      });
    }
    let nameFields = [
      {
        name: 'title',
        label: 'Anrede',
        type: 'titleSelect',
        required: true,
        // disabled: true,
        gridSize: { xs: 12, md: 3 },
      },
      {
        name: 'forename',
        label: 'Vorname',
        required: true,
        // disabled: true,
        gridSize: { xs: 12, md: 4 },
      },
      {
        name: 'name',
        label: 'Nachname',
        required: true,
        // disabled: true,
        gridSize: { xs: 12, md: 5 },
      },
    ];
    if (params?.useContactPerson) {
      nameFields = [
        {
          name: 'customAttributes.contactPersonTitle',
          label: 'Anrede',
          type: 'titleSelect',
          required: true,
          gridSize: { xs: 12, md: 3 },
        },
        {
          name: 'customAttributes.contactPersonForename',
          label: 'Vorname',
          required: true,
          gridSize: { xs: 12, md: 4 },
        },
        {
          name: 'customAttributes.contactPersonName',
          label: 'Nachname',
          required: true,
          gridSize: { xs: 12, md: 5 },
        },
      ];
    }

    const fields = [
      ...nameFields,
      {
        name: 'company',
        label: 'Firma',
        gridSize: { xs: 12 },
      },
      {
        name: 'customAttributes.street',
        label: 'Straße',
        required: true,
        gridSize: { xs: 12 },
      },
      {
        name: 'customAttributes.postalcode',
        label: 'PLZ',
        type: 'number',
        required: true,
        gridSize: { xs: 12, md: 3 },
      },
      {
        name: 'customAttributes.city',
        label: 'Ort',
        required: true,
        gridSize: { xs: 12, md: 9 },
      },
      {
        name: 'customAttributes.phone',
        label: 'Telefon',
        type: 'tel',
        // required: true,
        gridSize: { xs: 12 },
      },
      {
        name: params?.useContactPerson ? 'customAttributes.contactPersonEmail' : 'email',
        label: params?.useContactPerson ? 'E-Mail' : 'E-Mail (an diese E-Mail wird die Einlasskarte gesendet)',
        type: 'email',
        required: true,
        gridSize: { xs: 12 },
      },
    ];

    if (params?.customAttributes) {
      for (const attr of params.customAttributes) {
        fields.push({
          name: `customAttributes.${attr.code}`,
          label: attr.name,
          placeholder: attr.placeholder,
          gridSize: { xs: 12 },
        });
      }
    }
    return fields;
  }, [params?.useContactPerson, params?.customAttributes, steps, params?.customFieldDefinition, attributeQuotas]);

  useEffect(() => {
    fields.forEach((field) => {
      if (
        field.visibilityCondition
        && !evaluateVisibility(field.visibilityCondition, values)
        && get(values, field.name) !== undefined
      ) {
        form.change(field.name, undefined);
      }
    });
  }, [fields, values, form]);

  return (
    <Grid container spacing={2} sx={{ marginTop: '20px' }}>
      {fields.map((field) => (
        <InputField key={field.name} {...field} />
      ))}
    </Grid>
  );
}
